import { contentInstance } from '../Axios';
import { ApiUrls } from '../../../domain/Endpoints.domain';
import { TPageContent } from '@/entities/Content/ui/Content.types';

export const getHelpPage = async (slug: string) => {
    try {
        const { data } = await contentInstance.get<TPageContent>(`${ApiUrls.public.page}/${slug}`);
        return data;
    } catch (error) {
        return null;
    }
};
